import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../common/models/Visiable";
import { FinanceState } from "../models/FinanceState";

const setVisiableAddForm = (state: FinanceState, action: PayloadAction<Visiable>) => {
    state.visiableAddForm = action.payload.visiable;
}

export default setVisiableAddForm;